import React, { useState } from "react";
import { METRIC_BANDS, DEFAULT_VISIBLE_BANDS, ScenarioColumnPicker } from "./columnPickerShared";

export default function BudgetVsCurrentForecastTab({
  classes, ContractTable, CF_TOTAL, CF_DATA,
  BDG_TOTAL, BDG_DATA, VAR_TOTAL, VAR_DATA, fmtVar,
  periodMonthKeys, actualColumns, actualThroughMonth, liveTitle, fiscalYear,
}) {
  const year = String(fiscalYear || "");
  const [visibleBands, setVisibleBands] = useState(DEFAULT_VISIBLE_BANDS);
  const toggle = (key) =>
    setVisibleBands((prev) =>
      prev.includes(key)
        ? prev.length > 1 ? prev.filter((k) => k !== key) : prev
        : [...prev, key].sort((a, b) =>
            METRIC_BANDS.findIndex((m) => m.key === a) - METRIC_BANDS.findIndex((m) => m.key === b))
    );

  const picker = <ScenarioColumnPicker visible={visibleBands} onToggle={toggle} />;
  const actualProps = { actualColumns, actualThroughMonth };

  return (
    <div>
      <ContractTable title={liveTitle || "Current Month Actuals + Live Forecast"}
        subtitle="Live Scenario" totalRow={CF_TOTAL} rows={CF_DATA} year={year}
        classes={classes} visibleBands={visibleBands} controls={picker} periodMonthKeys={periodMonthKeys}
        {...actualProps} />
      {/* Budget has no actuals-through-month concept — omitting actualProps here (unlike the
          Live/Variance tables above) keeps its header row from being shaded Actual/Forecast. */}
      <ContractTable title="Budget"
        subtitle="Approved Budget" totalRow={BDG_TOTAL} rows={BDG_DATA} year={year}
        classes={classes} visibleBands={visibleBands} periodMonthKeys={periodMonthKeys} />
      <ContractTable title="Variance"
        subtitle="Live Forecast Vs Budget" totalRow={VAR_TOTAL} rows={VAR_DATA} year={year}
        classes={classes} formatter={fmtVar} visibleBands={visibleBands} periodMonthKeys={periodMonthKeys}
        {...actualProps} />
    </div>
  );
}
